import { store } from '@redux/store';
import {
  speedCurveTrackConversion,
  speedCurveMarkStart,
  speedCurveMarkEnd,
  speedcurveTimingMetric,
} from './redux/actions';
import selectIsInProgress from './redux/selectors';
import speedcurveStateSlice from './redux/slices';

const { actions, reducer } = speedcurveStateSlice;

store.injectReducer('speedcurveState', reducer);

require('./redux/beaconMiddleware');

export {
  speedCurveTrackConversion,
  speedCurveMarkStart,
  speedCurveMarkEnd,
  speedcurveTimingMetric,
  selectIsInProgress,
  actions as speedcurveStateActions,
};
